import { ICartState } from './types';

export const initialState: ICartState = {
    localCartId: null,
    items: [],
    isHydrated: false,
};
